import React from 'react';
import { Calendar } from 'primereact/calendar';
import { dictionary } from '../../../dictionary';

const InvoiceCompletion = ({ completionMonthYear, setCompletionMonthYear }) => {
  return (
    <>
      <div className="field-col">
        <label>{dictionary.esp_dialog_invoice_completion}</label>
        <Calendar
          style={{ width: '100%' }}
          value={completionMonthYear}
          onChange={(e) => {
            setCompletionMonthYear(e.value);
          }}
          showIcon
          view="month"
          dateFormat="mm-yy"
        />
      </div>
    </>
  );
};

export default InvoiceCompletion;
